module.exports = {
    __lang__: 'zh-tw'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/locale.zh-tw.js
 ** module id = 6
 ** module chunks = 0
 **/